import React from 'react'
import LotAngle from '../../Images/LotAngle.svg'
import { useTranslation } from 'react-i18next';

const LawHelpTable = ({ data, closeModal }) => {
    const { t } = useTranslation()
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 
                        flex justify-center items-center z-50">
            <div className="bg-white dark:bg-dark-box py-4 xl:py-8 pl-4
                            xl:pl-8 pr-4 w-full max-w-4xl xl:rounded-md h-full
                            xl:h-max dark:text-white">
                <div className='news overflow-y-scroll pr-4'>

                <div className="w-full text-center font-bold text-2xl 
                                text-primary dark:text-dark-text">
                    <h1>{data.title}</h1>
                </div>

                <div className="mt-4">
                    <table className="w-full text-center">
                        <thead>
                            <tr>
                                <th className="border border-border p-1">
                                    {t('recipient')
                                    }</th>
                                <th className="border border-border p-1 xl:p-0">
                                    {t('accept_time')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.content?.map((content, index) => (
                                <tr key={index}>
                                    <td className="border border-border p-1">
                                        {content.name
                                        }</td>
                                    <td className="border border-border p-1 xl:p-0">
                                        {content.day &&
                                            <p className="border-b border-b-border py-2">
                                                {content.day}
                                            </p>
                                        }
                                        {content.time &&
                                            <p className="py-2">
                                                {content.time}
                                            </p>
                                        }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Address */}
                {data.address?.length > 0 && (
                    <ul className="mt-8">
                        {data.address.map((addr, index) => (
                            <li key={index} className="flex gap-2">
                                <img src={LotAngle} alt="icon" />
                                <em>{t('address')}: {addr.address}</em>
                            </li>
                        ))}
                        {data.address.map((addr, index) => (
                            <li key={index} className="flex gap-2">
                                <img src={LotAngle} alt="icon" />
                                <em>{t('accept_time')}: {addr.time}</em>
                            </li>
                        ))}
                        {data.address.map((addr, index) => (
                            <li key={index} className="flex gap-2">
                                <img src={LotAngle} alt="icon" />
                                <em>{t('telephone')}: {addr.phone}</em>
                            </li>
                        ))}
                    </ul>
                )}

                {/* Close Button */}
                <div className="text-right mt-4">
                    <button
                        className="text-white bg-red py-1 px-4 
                                   rounded dark:text-dark-text"
                        onClick={closeModal}
                    >
                        {t('close')}
                    </button>
                </div>
                </div>
            </div>
        </div>
    );
}

export default LawHelpTable;
